<div class="page-body-wrapper">
    <div class="row">
        <div class="col-lg-12">
            <div>

                <button mat-raised-button color="primary" (click)="openCreateModal()">
                    <mat-icon>add</mat-icon>
                    <span>Yeni Kullanıcı Ekle</span>
                </button>
                <!--        <button mat-raised-button color="link" (click)="filteredData()" style="margin-left: 10px;">Filtrele</button>-->


            </div>
            <div class="row filter-wrapper">
                <div class="col-lg-2">
                    <mat-form-field class="absence-form-field">
                        <mat-label>Ad</mat-label>
                        <input [(ngModel)]="filterName" matInput placeholder="Ahmet">
                    </mat-form-field>
                </div>
                <div class="col-lg-2">
                    <mat-form-field class="absence-form-field">
                        <mat-label>Soyad</mat-label>
                        <input [(ngModel)]="filterSurname" matInput placeholder="Yılmaz">

                    </mat-form-field>
                </div>

                <div class="col-lg-3">
                    <label id="radio-group-label">Kullanıcı Tipi:</label>
                    <mat-radio-group [(ngModel)]="activeFilter">
                        <mat-radio-button *ngFor="let active of activeList" [value]="active.value" class="radio-button"
                            color="primary" style="margin:5px">
                            {{active.description}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-lg-3 table-header-button-wrapper">
                    <button (click)="filterGrid()" color="warn" mat-raised-button style="margin-right: 5px;">Filtrele
                    </button>
                    <button (click)="clearFilterGrid()" color="link" mat-raised-button style="margin-right: 5px;">
                        Temizle
                    </button>
                </div>

            </div>

            <mat-table [dataSource]="dataSource" class="lessons-table mat-elevation-z8">

                <ng-container matColumnDef="employeename">
                    <mat-header-cell *matHeaderCellDef> Çalışan Adı Soyadı</mat-header-cell>
                    <mat-cell *matCellDef=" let element"> {{element.employeename}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="username">
                    <mat-header-cell *matHeaderCellDef> Kullanıcı Adı</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.username}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="email">
                    <mat-header-cell *matHeaderCellDef> Email</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.email}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let element" class="actions-mat-cell">
                        <button (click)="openUpdateModal(element)"
                                mat-icon-button
                                class="portaluser-iconbutton action-edit-button"
                                matTooltip="Düzenle"
                                matTooltipPosition="above">
                            <mat-icon class="portaluser-action-icon">edit</mat-icon>
                        </button>
                        <button (click)="openDeleteModal(element)"
                                mat-icon-button
                                class="portaluser-iconbutton action-delete-button"
                                matTooltip="Sil"
                                matTooltipPosition="above">
                            <mat-icon class="portaluser-action-icon">delete_forever</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

            </mat-table>
            <mat-paginator #userPaginator="matPaginator" (page)="UserPageEvent($event)"
                [pageSizeOptions]="[10, 20, 50,100]" showFirstLastButtons></mat-paginator>

        </div>
    </div>
</div>